import { useEffect, useState } from "react";

import styled from 'styled-components';
import { useQuery } from "../../hooks/useQuery";
import { fetchData } from "../../util/savingsApi";
import ListItem from "./ListItem/ListItem";

export default function SavingsAccounts() {
    let query = useQuery();

    const [listings, setListings] = useState([])

    useEffect(() => {
    const updateBankrateData = async () => {
      const response = await fetchData();
      if (response.message === "success") {
        let listingData = response.data.data.savings_mma_rates;

        console.log('listingData', listingData);

        const pid = 'myfi_ratezip_api';
        const ppcid = query.get("ppcid") || '7';
        const cid = query.get("cid") || 'ratezip';

        window.dataLayer.push({
          'listing_count': listingData.length,
          'event': 'listings_are_loaded'
        });

        setListings(listingData.map((i, index) => {
          return (
            <ListItem
              key={index + 1}
              id={index + 1}
              name={i.institution.name}
              product={i.product.name}
              isCheckwrite={i.is_checkwrite}
              monthlyService={i.fees.monthly_service.toFixed(2)}
              offerDetails={i.offer_details}
              minToAvoidFee={i.fees.min_to_avoid_fees.toFixed(2)}
              apy={i.apy}
              logo={i.institution.logo_url}
              advertiser_notes={i.advertiser_notes}
              min_to_open={i.min_to_open.toFixed(2)}
              phone={i.phone}
              link={`${i.ep_url}?clkid=${ppcid}_${cid
                }&utm_source=RateZip+API&pid=${pid}&utm_medium=partner`}
              rating={i.institution.reviews.savings_rating || i.institution.reviews.overall_rating}
              effective_at={i.effective_at}
              member={i.institution.insurance_information.type}
              buttonTitle="View Rate"
            />
          );
        }))
      }
    }

    updateBankrateData()
  }, [query]);

  return (
    <>
        <h2>Other Ways to Save</h2>
        <ResultListContainer>
            {listings}
        </ResultListContainer>
    </>
  );
}

const ResultListContainer = styled.div`
    width: 100%;

    > p {
        padding: 20px 0px;
        text-align: center;
    }
`;